import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../../context/AuthContext';
import styles from './Auth.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const RegisterForm = ({ onSwitchToLogin, onRegisterSuccess }) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { register, loading } = useAuth();
  const [registerError, setRegisterError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setRegisterError('');

    const result = await register({
      first_name: firstName,
      last_name: lastName,
      email: email,
      password: password
    });
    
    if (result.success) {
      onRegisterSuccess();
    } else {
      setRegisterError(result.error || 'Registration failed. Please try again.');
    }
  };

  return (
    <div className={styles.formSection}>
      <h2>Join Us!</h2>
      <p>Sign up to start your journey.</p>
      <form onSubmit={handleSubmit} className={styles.authForm}>
        <div className={`form-group ${styles.stackingGroup}`}>
          <label htmlFor="firstName">First Name</label>
          <input
            type="text"
            id="firstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
            placeholder="Enter your first name"
            autoComplete="given-name"  
          />
        </div>
        <div className={`form-group ${styles.stackingGroup}`}>
          <label htmlFor="lastName">Last Name</label>
          <input
            type="text"
            id="lastName"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
            placeholder="Enter your last name"
            autoComplete="family-name" 
          />
        </div>
        <div className={`form-group ${styles.stackingGroup}`}>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Enter your email"
            autoComplete="email"
          />
        </div>
        <div className={`form-group ${styles.stackingGroup}`}>
            <div className={styles.labelWithLink}>
            <label htmlFor="password">Password</label>
          </div>
          <div className={styles.passwordInputContainer}>
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
              className={styles.passwordInput}
              autoComplete="new-password"
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className={styles.passwordToggle}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </button>
          </div>
          </div>
        {registerError && <div className={styles.error}>{registerError}</div>}
        <button type="submit" className={styles.submitButton} disabled={loading}>
          {loading ? 'Registering...' : 'Register'}
        </button>
      </form>
      <p className={styles.switchForm}>
        Already have an account? <span onClick={onSwitchToLogin}>Login here</span>
      </p>
    </div>
  );
};

RegisterForm.propTypes = {
  onSwitchToLogin: PropTypes.func.isRequired,
  onRegisterSuccess: PropTypes.func.isRequired,
};

export default RegisterForm;